export default "__VITE_ASSET__BcOvl0LF__"